import { useCallback, useEffect, useRef } from "react";
import { useAuth } from "react-oidc-context";

export function useGetAccessToken(): () => Promise<string | undefined> {
  const auth = useAuth();
  const authRef = useRef(auth);

  useEffect(() => {
    authRef.current = auth;
  }, [auth]);

  return useCallback(async () => {
    const currentAuth = authRef.current;
    if (currentAuth.user && !currentAuth.user.expired) {
      return currentAuth.user.access_token;
    }
    try {
      const refreshedUser = await currentAuth.signinSilent();
      return refreshedUser?.access_token;
    } catch (e) {
      // TODO: replace with signinRedirect() once the token refresh issue is confirmed resolved.
      // await currentAuth.signinRedirect();
      // return undefined;
      throw e;
    }
  }, []);
}
